import React, { useState } from 'react';
import OptionsAndOther from '../../choose_an_option';

export default function ReasonForSwitch({ answers, onSubmit, onBack, gtm, showBack }) {
  return (
    <div className={`row activity-question`}>
      <div className='col-sm-2'></div>
      <div className='col-sm-8'>
        <OptionsAndOther
          answers={{ xcopriReasonForSwitch: answers.xcopriReasonForSwitch }}
          onSubmit={(newAnswers) =>
            onSubmit({ ...answers, xcopriReasonForSwitch: newAnswers.xcopriReasonForSwitch, other: newAnswers.other })
          }
          onBack={onBack}
          title={`What are the reasons you would like to switch to XCOPRI® (cenobamate tablets) CV?`}
          keyForAnswer={`xcopriReasonForSwitch`}
          choices={[
            `I'm still experiencing seizures`,
            'Tolerability issues with current ASM',
            `The cost is too high or my insurance doesn't cover it`,
          ]}
          selectOne={false}
          showOther={true}
          otherTxt={`Other (please list)`}
          showBack={showBack}
        />
      </div>
      <div className='col-sm-2'></div>
    </div>
  );
}
